export const defaultControles = () => {
    return {
        id:"",
        codigo:'',
        control:'',
        activo:1,
    }
}
export const defaultListas = () => {
  return {
        id:"",
        codigo:'',
        lista: '',
        activo: 1,
  }
}

export const defaultFiltroListas = () => {
    return {
        buscar: '',
        id_control: '',
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'ASC',
        estado: [1]
    }
}

export const defaultFiltroControles = () => {
    return {        
        buscar: '',
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'ASC',
        estado: [1]
    }
}

export default {
    descripcionRol: '',
    roles: [],
    permisos: [],
    buscaPermiso: "",
    permisosSeleccionados: [],
    rolesSeleccionados: [],
    rolusuario: 1,
    busca : {
      permiso: '',
      key: ''
    },
    controles:[],
    nombreControl: '',
    listas:[],
    visualizarModalControles: false,
    visualizarModalListas: false,
    controlSelect:[],
    accionControl:'Crear',
    accionLista:'Crear',
    selectedControles:defaultControles(),
    selectedListas:defaultListas(),
    filtroListas: defaultFiltroListas(),
    filtroControles: defaultFiltroControles()
}
